
/** API Reference 
    Owl carousel -  http://www.owlcarousel.owlgraphic.com/docs/started-welcome.html
    Bootstrap - http://getbootstrap.com/javascript/
    Fancybox - https://fancyapps.com/fancybox/3/docs/
    SmartMenus - http://www.smartmenus.org/docs/

    */
/** --------------- DO NOT EDIT BELOW THIS LINE --------------- */


/** lazy load when scroll to image tag from screen */
document.addEventListener("DOMContentLoaded", function () {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazyImg"));

    if ("IntersectionObserver" in window) {
        var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                // console.log("entry lazyImg", entry);
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    var lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.imgsrc;
                    lazyImage.classList.remove("lazyImg");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        }, {
            rootMargin: "200px",
            threshold: 0.05
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // fallback
        $.each($("img.lazyImg"), function (n, i) {
            var t = $(this).data('imgsrc');
            $(this).attr("src", t);
        });
    }
});

//lazy load when use background images
document.addEventListener("DOMContentLoaded", function () {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazyBackground"));

    if ("IntersectionObserver" in window) {
        var lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                // console.log("entry background", entry);
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    var lazyImage = entry.target;
                    var imgUrl = lazyImage.dataset.imgsrc;
                    lazyImage.classList.remove("lazyBackground");
                    lazyBackgroundObserver.unobserve(lazyImage);
                    entry.target.style.backgroundImage = "url(" + imgUrl + ")";

                }
            });
        }, {
            rootMargin: "200px",
            threshold: 0.05
        });

        lazyBackgrounds.forEach(function (lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    } else {
        // fallback
        $.each($(".lazy-background"), function (n, i) {
            var bgurl = $(this).data('imgsrc');
            $(this).css('background-image', 'url(' + bgurl + ')');
        });
    }
});

/* deferred video/iframe/img until after the initial pageload  */
function deferload() {
    $.each($("iframe , img , source"), function (n, i) {
        var t = $(this).data('src');
        $(this).attr("src", t);
    });
}

/* synced owl */
function syncedowl(bigimages, thumbs, bigimagesargs, thumbsargs, popuptype) {
    /* synced carousel variables */
    var sync1 = $(bigimages),
        sync2 = $(thumbs)
    flag = false,
        duration = 300;
    /* parsing args */
    if (sync1.length) {
        sync1.owlCarousel(bigimagesargs).on('changed.owl.carousel', function (e) {
            /* apply sync position on change */
            var realIndex = (e.property.value - Math.ceil(e.item.count / 2)) % e.item.count || 0;
            syncPosition(e);
            if (!flag) {
                flag = true;
                sync2.trigger('to.owl.carousel', [realIndex, duration, true]);
                flag = false;
            }

        });
    }


    /* parsing args */
    if (sync2.length) {
        sync2.owlCarousel(thumbsargs).on('click', '.owl-item', function () {
            sync1.trigger('to.owl.carousel', [$(this).index(), duration, true]);
            console.log($(this));
        })
            .on('changed.owl.carousel', function (e) {
                var realIndex = (e.property.value - Math.ceil(e.item.count / 2)) % e.item.count || 0;
                if (!flag) {
                    flag = true;
                    sync1.trigger('to.owl.carousel', [realIndex, duration, true]);
                    flag = false;
                }
            });
        /* add synced class on init */
        sync2.find(".owl-item").eq(0).addClass('synced');

    }
    /* sync position */
    function syncPosition(el) {
        var current = el.item.index;
        sync2
            .find(".owl-item").removeClass('synced').eq(current).addClass('synced');
    }
}

/* activate hamburger navigation */
function hamburgerdrop(elemclick, target, animargs) {
    if (elemclick.length) {
        $(elemclick).click(function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            /* toggle expanded target */
            $('.expand').map(function (index) {
                if ($(this)[0] !== $(target)[0]) {
                    $(this).toggleClass('expand').stop(true, true).animate(animargs, 100);
                }
            });
            /* toggle open elemclick */
            $('.open').map(function (index) {
                if ($(this)[0] !== $(elemclick)[0]) {
                    $(this).toggleClass('open');
                }
            });

            $("#book-comp").hide();

            $(".open-offer a").trigger('click');

            /* toggle hamburger */

            if ($(this).siblings('.menu-toggle').length) {
                $('.menu-toggle').toggleClass('open');
            } else {
                $(this).toggleClass('open');
            }
            $(target).toggleClass('expand').stop(true, true).animate(animargs, 100);

            //body overflow hide show
            if ($('.main-menu-container').hasClass('expand') || $('.plan-your-gateway-container').hasClass('expand')) {
                // $("body").css('overflow', 'hidden'); 
            } else {
                // $("body").css('overflow', 'auto'); 
            }
        });
    }
    /* not target click handle */
    $(document).click(function (e) {
        if ($(target).is(":visible") && $(target).prevUntil('.menu-toggle').is(":visible") && !$(target).is(e.target)) {
            $(elemclick).toggleClass('open');
            $(target).toggleClass('expand').stop(true, true).animate(animargs, 100);
        }

        //check gateway btn open class
        if ($(elemclick).hasClass('mobile-gateway-btn')) {
            if ($('.plan-your-gateway-container').is(":visible")) {
                $('.plan-your-gateway-container').toggleClass('expand').stop(true, true).animate(animargs, 100);
            }
        }

    });

    $(target).click(function (e) {
        e.stopPropagation();
    });
}

/* owls on required devices only */
function owlsonrequireddevicesonly(elem, breakpoint, args) {
    if ($(elem)[0]) {
        var s = $(elem);
        if (window.innerWidth < breakpoint) {
            s.owlCarousel(args)
        } else s.addClass("off");
        /* destroy owl carousel on resize */
        $(window).resize(function (e) {
            if (window.innerWidth < breakpoint) {
                if ($(elem).hasClass("off")) {
                    s.owlCarousel(args);
                    s.removeClass("off")
                }
            } else $(elem).hasClass("off") || (s.addClass("off").trigger("destroy.owl.carousel"), s.find(".owl-stage-outer").children(":eq(0)").unwrap())
        })
    }
}


/* --------------- DO NOT EDIT ABOVE THIS LINE --------------- */

/* loading different resources for mobile and desktop users */

if (window.matchMedia("(min-width: 1200px)").matches) {
    /* the view port is at least 1200 pixels wide */
    $(window).scroll(function (e) {
        /*hide datpicker on scroll*/
    });
} else {
    /* the view port is less than 1200 pixels wide */
}

function checkScrollPosition() {
    if ($(window).scrollTop() > 200) {
        $('.main-navigation').addClass('scroll-fix');
        $('body').addClass('scroll-fix');
        $('.comp-booknow').addClass('fix-ibe');
    }
    if ($(window).scrollTop() < 200) {
        $('.main-navigation').removeClass('scroll-fix');
        $('body').removeClass('scroll-fix');
        $('.comp-booknow').removeClass('fix-ibe');
    }

    // if ($(window).scrollTop() > 950) {
    //     $('.comp-booknow').addClass('fix-ibe');
    // }
    // if ($(window).scrollTop() < 950) {
    //     $('.comp-booknow').removeClass('fix-ibe');
    // }
}


/* create your functions here */

// Initial state
var scrollPos = 0;
$(window).scroll(function (e) {

    checkScrollPosition();
    //add class to body with direction of scrolling
    if ((document.body.getBoundingClientRect()).top > scrollPos) {
        $('.mobile-gateway-btn').removeClass('direction-down');
        $('.mobile-gateway-btn').addClass('direction-up');

    } else {
        $('.mobile-gateway-btn').removeClass('direction-up');
        $('.mobile-gateway-btn').addClass('direction-down');
    }
    // saves the new position for iteration.
    scrollPos = (document.body.getBoundingClientRect()).top;

    if ($(window).scrollTop() == 0) {
        $('.mobile-gateway-btn').removeClass('direction-down direction-up');
    }
});

/* ------------------------- executes when complete page is fully loaded ----------------------------- */
$(window).on("load", function (e) {

    /* smart menu */
    // if ($('#main-menu').length) {
    //     sliderMenu = $('#main-menu').sliderMenu();
    // }   


    $("input[name=frm-nationality]").flexdatalist({
        selectionRequired: 1,
        minLength: 0,
        maxShownResults: 250,
    });


    // waypoint aniamtion
    //set a waypoint for all the page parts on the page
    var ppWaypoint = $('.animate-section').waypoint(function (direction) {
        //check the direction
        if (direction == 'down') {
            //add the class to start the animation
            $(this.element).addClass('show');
        } else {
            $(this.element).removeClass('show');
        }
    }, {
        //Set the offset
        offset: '120%'
    });

    $('grid').masonry();


    // nice select
    $(".nice-select-booking").niceSelect();

    /* IBE*/
    $(".book-now-btn").click(function () {
        //$("#book-comp").slideToggle("fast");
        $(this).toggleClass("is-active");
        $(".main-menu-container").hide();
        $(".menu-toggle").removeClass("open");
    });
    $(".closs_ibe").click(function () {
        $("#book-comp").hide();
        $(".main-menu-container").hide();
        $(".menu-toggle").removeClass("open");
    });

    $(".btn_closs_menu").click(function () {
        $(".mainmenutoggle").trigger("click");
    });

    /*$(document).ready(function () {
        $('.all-book-now').click(function (event) {
            //event.preventDefault();
            //alert('offers');
            //var promoCode = $(this).data("promo");
            //$('#promocode').val(promoCode);
            //$('#book-comp').show();
            //errorfix
        });
    });*/


    /* fancybox 3 */
    if ($('[data-fancybox]').length) {
        $('[data-fancybox]').fancybox();
    }

    // gallery page
    $(".gallery-nav li").each(function (i) {
        $(this).click(function () {
            $("#tabwrapper").find(".tabgal:eq('" + i + "')").show().siblings().hide();
            $("#left-navbar").hide();
            $("#gallery-toggle").removeClass("open");
            $(".gallery-nav li").removeClass("active");
            $(this).addClass("active");

            $("#addtitle").empty();
            $("#addtitle").append($(this).text());
            // console.log(gettext);
        });
    });

    /* smart menu */
    if ($('#main-menu').length) {
        $("#main-menu").smartmenus().bind("click.smapi", function (e, t) {
            var n = $(this).data("smartmenus");
            if (n.isCollapsible()) {
                var i = $(t);
                o = i.dataSM("sub");
                if (o && !o.is(":visible")) return n.itemActivate(i, !0), !1
            }
        });
    }

    if ($('#main-menu-hotel').length) {
        $("#main-menu-hotel").smartmenus().bind("click.smapi", function (e, t) {
            var n = $(this).data("smartmenus");
            if (n.isCollapsible()) {
                var i = $(t);
                o = i.dataSM("sub");
                if (o && !o.is(":visible")) return n.itemActivate(i, !0), !1
            }
        });
    }


    spoffersArgs = {
        items: 1,
        loop: !1,
        autoplay: !1,
        nav: 0,
        dots: true,
        autoplayHoverPause: true,
        navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#left-arrow"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#right-arrow"></use></svg>'],
        lazyLoad: !0,
        responsive: {

            1200: {
                items: 3,
                nav: 0
            }
        }
    }
    $element = $('.owl-special-offers');
    if ($element.length) {
        owlsonrequireddevicesonly($element, 992, spoffersArgs);
    }

    // home awards: continuous linear slider, 2 per view, only below 600px
    awordsArgs = {
        items: 2,
        loop: !0,
        autoplay: !0,
        // timeout must equal the slide speed so each linear move ends as the next starts
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        smartSpeed: 3000,
        slideTransition: "linear",
        autoplayHoverPause: !1,
        mouseDrag: !1,
        touchDrag: !1,
        pullDrag: !1,
        dots: !1,
        nav: !1,
    }
    $awords = $('.comp-hm-awords');
    if ($awords.length) {
        owlsonrequireddevicesonly($awords, 600, awordsArgs);
    }


    b = {
        items: 1,
        dots: 1,
        loop: false,
        lazyLoad: true,
        responsive: {
            0: {
                dots: 1
            },
            768: {
                dots: 0,
                nav: true,
                autoplayHoverPause: true,
                navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#leftarrow"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#rightarrow"></use></svg>'],
            }
        }
    }

    t = {
        loop: 1,
        lazyLoad: true,
        responsive: {
            0: {
                items: 1,
                dots: 1
            },
            768: {
                items: 6,
                margin: 7
            }
        }
    }

    $largeslider = $('.owl-hm-gallery-large');
    $thumbslider = $('.owl-hm-gallery-thumb');

    /** @param
        0 - elem id / elem class - big images
        1 - elem id / elem class - thumb images
        2 - big images carousel args
        3 - thumbs carousel args
        4 - magnificpopup type ex: image/iframe
        */

    syncedowl($largeslider, $thumbslider, b, t, "image");

    // gallery tab
    /*activate gllery page tabs */
    $(document).on('click', '.gallery-tabs .nav-link', function () {
        var currentVal = $(this).attr('data-value');
        $('.gallery-tabs .nav-link').removeClass('active');

        $(this).addClass('active');

        $('.gallery .wrap').each(function () {
            var attr = $(this).attr('data-value');
            if (attr == currentVal) {
                $('.gallery .wrap').removeClass('visible');
                $(this).addClass('visible');
            }
        });
    });


    homeExpArgs = {
        items: 1,
        // loop: !0,
        autoplay: !1,
        margin: 10,
        dots: !0,
        animateOut: "fadeOut",
        mouseDrag: false,
        touchDrag: false,
        autoHeight: true,
        lazyLoad: true,
        responsive: {
            768: {
                dots: !0,
                margin: 10,
            },
            992: {
                dots: !0,
                margin: 10,
            },
            1200: {
                dots: !0,
                margin: 10,
                nav: !0,
                navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#right"></use></svg>'],
            }
        }
    }
    $('.owl-home-dining').owlCarousel(homeExpArgs);

    // dining slider functions Home page
    function diningslider() {
        $('.dining-index').click(function (e) {
            e.preventDefault();
            var indexnumber = $(this).data('item-index');
            $('.owl-home-dining').trigger('to.owl.carousel', indexnumber, 300);
            $('.dining-index').removeClass("active");
            $(this).addClass("active");
        });

        $('.owl-home-dining').on('changed.owl.carousel', function (event) {
            var idx = event.item.index;
            $('.dining-index').removeClass("active");
            $('.dining-index').eq(idx).addClass("active");
            var list_text = $('.dining-index').eq(idx).text();
            $('.dropdown .btn-secondary span.text-only').html(list_text);
        });
    };

    diningslider();

    /* create var */
    var html = "";
    var video = "";
    var vids = [];
    var player = [];
    var description = "";
    var linkurl = "";
    var target = "";
    /* ---------- array check & create html slides - responsive ---------- */
    if (typeof imageArray != 'undefined') {
        for (var i = 1; i < imageArray.length; i++) {
            /* check for the video url and include it in the slider */
            if (imageArray[i]['videourl'] != '') {
                /* loading video above 1200px */
                if (window.matchMedia("(min-width: 1199px)").matches) {
                    video = '<video data-id="' + i + '" id="videoid_' + i + '" class="video-js" controls muted crossorigin autoplay>' +
                        '<source src="' + imageArray[i]['videourl'] + '" type="' + imageArray[i]['videotype'] + '">' +
                        '</video>';

                    /*collect video id's in to an array */
                    vids[i] = "videoid_" + i;
                }

            }
            /* check for the link  */
            if (imageArray[i]['linkurl'] != '') {
                linkurl = '<a href="' + imageArray[i]['linkurl'] + '" class="linkurl clearfix" target="' + imageArray[i]['target'] + '">' + imageArray[i]['linktext'] + '</a>';
            }

            /* check for the title & description */
            if (imageArray[i]['displaytext'] != '') {
                description = '<div class="description' + ' ' + imageArray[i]['displaylocation'] + '">' + imageArray[i]['displaytext'] + linkurl + '</div>';
            }

            html += '<div class="item">' + video +
                '<picture>' +
                '<source media="(max-width: 768px)" srcset="' + imageArray[i]['mobileimgurl'] + '">' +
                '<img class="img-responsive" src="' + imageArray[i]['desktopimgurl'] + '" alt="' + imageArray[i]['alt'] + '" title="' + imageArray[i]['title'] + '">' +
                '</picture>' + description +
                '</div>';

            /* unset var */
            video = '';
            description = '';
            linkurl = '';
            target = '';
        }
    }

    /* ---------- array check & create html slides for fullscreen ---------- */
    if (typeof imageArrayfullscreen != 'undefined') {
        for (var i = 1; i < imageArrayfullscreen.length; i++) {
            /* check for the video url and include it in the slider */
            if (imageArrayfullscreen[i]['videourl'] != '') {
                /* loading video above 1200px */
                if (window.matchMedia("(min-width: 1199px)").matches) {
                    video = '<video data-id="' + i + '" id="videoid_' + i + '" class="video-js" controls muted crossorigin autoplay>' +
                        '<source src="' + imageArrayfullscreen[i]['videourl'] + '" type="' + imageArrayfullscreen[i]['videotype'] + '">' +
                        '</video>';

                    /*collect video id's in to an array */
                    vids[i] = "videoid_" + i;
                }
            }
            /* check for the link  */
            if (imageArrayfullscreen[i]['linkurl'] != '') {
                linkurl = '<a href="' + imageArrayfullscreen[i]['linkurl'] + '" class="linkurl clearfix" target="' + imageArrayfullscreen[i]['target'] + '">' + imageArrayfullscreen[i]['linktext'] + '</a>';
            }

            /* check for the title & description */
            if (imageArrayfullscreen[i]['displaytext'] != '') {
                description = '<div class="description' + ' ' + imageArrayfullscreen[i]['displaylocation'] + '">' + imageArrayfullscreen[i]['displaytext'] + linkurl + '</div>';
            }
            html += '<div class="item" style="background-image: url(' + imageArrayfullscreen[i]['desktopimgurl'] + ')">' + video +
                '<img class="img-responsive" src="' + imageArrayfullscreen[i]['mobileimgurl'] + '" alt="' + imageArrayfullscreen[i]['alt'] + '" title="' + imageArrayfullscreen[i]['title'] + '">' + description +
                '</div>';

            /* unset var */
            video = '';
            description = '';
            linkurl = '';
            target = '';
        }
    }

    /* carousel args */

    args = {
        items: 1,
        autoplay: !0,
        loop: !0,
        dots: !1,
        animateOut: "fadeOut",
        onChanged: function (event) {
            /* init videojs */
            if (vids.length) {
                $.each(vids, function (key, value) {
                    if (value) {
                        player[key] = videojs(value);
                    }

                });
            }

            /* loading different resources for mobile and desktop users */
            if (window.matchMedia("(max-width: 1200px)").matches) {
                /* stop all playing videos*/
                $("#eme-slider video").each(function () {
                    $(this).get(0).pause();
                });
                /* trigger autoplay */
                $(event.target).trigger('play.owl.autoplay');

            } else {

                var Obj = $(event.target).find(".owl-item").eq(event.item.index).has('video');
                /*check for the video*/
                if (Obj.length) {
                    /*stop owl if video */
                    $(event.target).trigger('stop.owl.autoplay');

                    /* stop all playing videos*/
                    $("#eme-slider video").each(function () {
                        $(this).get(0).pause();
                    });

                    /*play video*/
                    var objectid = Obj.find('video').data('id');
                    player[objectid].play().on('ended', function () {
                        /* trigger autoplay */
                        $(event.target).trigger('play.owl.autoplay');
                    });
                } else {
                    /* trigger autoplay */
                    $(event.target).trigger('play.owl.autoplay');
                }
                Obj = '';
            }
        }
    }
    /* init slider */
    if ($('#eme-slider').length) {
        /* apply carousel only if slider items > 1 */
        if (typeof imageArraycount != 'undefined') {
            if (imageArraycount != 1) {
                $('#eme-slider').append(html).owlCarousel(args);
            }
        }

    }

    /**----------------------------------------------- Multiple Videos with Image slider ----------------------------------------------
     * Video first slide with slider
     * 2018 december development
     */

    var videoPlayer = [];
    var videoList = [];
    var playerInitialized = false;
    var optionsPlayer = {
        autoplay: false,
    }

    //checking video or image and do the process
    function sliderRun(event) {

        /*stop owl autoplay  */
        $(event.target).trigger('stop.owl.autoplay');

        //pause all video players
        for (var i = 0; i < videoPlayer.length; i++) {
            if (videoPlayer[i] != undefined) {
                videoPlayer[i].pause();// pause the player
                videoPlayer[i].currentTime(0);// set first frame of the video
            }
        }

        //check disable video js on mobiles
        if (window.matchMedia("(max-width: 1200px)").matches) {
            /* trigger autoplay */
            $(event.target).trigger('play.owl.autoplay', [7000]);

        } else {
            var Obj = $(event.target).find(".owl-item").eq(event.item.index).has('video');

            /*check for the video*/
            if (Obj.length) {

                var objectid = Obj.find('video').attr('data-id');

                //check video download time
                function checkDownloadTime() {
                    var howMuchIsDownloaded = videoPlayer[objectid].bufferedPercent();
                    if (howMuchIsDownloaded > 0) {
                        //video totally downloaded
                        stopchecking();
                    }
                }

                //stop video download time checking
                function stopchecking() {
                    clearInterval(downloadTimeCheck);
                    playVideo();
                }

                //play current video
                function playVideo() {
                    videoPlayer[objectid].play();
                    videoPlayer[objectid].on('ended', function () {
                        /* trigger autoplay */
                        $(event.target).trigger('play.owl.autoplay', [300]);
                    });
                }

                var downloadTimeCheck = setInterval(checkDownloadTime, 300);

            } else {

                /* trigger autoplay */
                $(event.target).trigger('play.owl.autoplay', [7000]);

            }

            Obj = '';
        }
    }

    //owl carousel on init
    function onInitialized(event) {
        var owlItems = $(event.target).find(".owl-item");

        //check video items and assign IDs
        owlItems.each(function (idx, item) {
            if ($(item).find('video').length) {
                $(item).find('video').attr('id', 'video_' + idx);
                $(item).find('video').attr('data-id', idx);
                var videoId = 'video_' + idx;
                videoList[idx] = videoId;
            }
        });

        if (videoList.length) {
            //initialize video players
            $.each(videoList, function (key, value) {
                if (value) {
                    videoPlayer[key] = videojs(value, optionsPlayer, ready);
                }
            });
        } else {
            //if not available first slide video
            sliderRun(event);
        }

        //video player ready state
        function ready() {
            if (playerInitialized == false) {
                playerInitialized = true; // set player initialized
                sliderRun(event);
            }
        }
    }

    //owl carousel on changed
    function onChanged(event) {
        if (playerInitialized) {
            sliderRun(event);
        }
    }

    // single video or image available state
    function onlySingleVideoAvailable() {
        if (window.matchMedia("(min-width: 1200px)").matches) {
            if ($('#eme-slider-v2').find('video').length) {
                var optionsSinglePlayer = {
                    autoplay: false,
                    loop: true,
                }
                var singleVideoPlayer = '';
                var obj = $('#eme-slider-v2').find('video').attr('id', 'single_video_player');

                singleVideoPlayer = videojs('single_video_player', optionsSinglePlayer, singlePlayerReady);

                function singlePlayerReady() {
                    singleVideoPlayer.play();
                }
            }
        }
    }

    //single video or image available with init owl carousel
    function onlySingleVideoAvailableWithOwlCarousel(argsSlider) {
        argsSlider.loop = false;
        argsSlider.mouseDrag = false;
        argsSlider.touchDrag = false;
        argsSlider.pullDrag = false;
        argsSlider.freeDrag = false;

        //video loop enable
        optionsPlayer.loop = true;
        $('#eme-slider-v2').append(htmlBlock).owlCarousel(argsSlider);
    }

    //init eme slider version 2 slider
    if ($('#eme-slider-v2').length) {
        var argsSlider = {
            items: 1,
            autoplay: false,
            loop: true,
            dots: false,
            animateOut: "fadeOut",
            nav: true,
            navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#leftarrow"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#rightarrow"></use></svg>'],
            onInitialized: onInitialized,
            onChanged: onChanged,
        }

        var htmlBlock = '';
        if (typeof videoFirstSliderArray != 'undefined') {
            htmlBlock = videoFirstSliderArray;
        }

        /* apply carousel only if slider items > 1 */
        if (typeof videoFirstSliderArraycount != 'undefined') {
            if (videoFirstSliderArraycount > 1) {
                //more than 1 items available
                $('#eme-slider-v2').append(htmlBlock).owlCarousel(argsSlider);
            }
            else {
                // please use only one method at a time 

                /** with owl carousel init method **/
                //onlySingleVideoAvailableWithOwlCarousel(argsSlider);

                /** without owl carousel init method **/
                onlySingleVideoAvailable();

            }
        }
    }


    // Contact form validate signup form on keyup and submit
    if ($('#contact-form').length) {
        $("#contact-form").validate({
            errorElement: 'span',
            errorClass: 'error jq-msg',
            normalizer: function (value) {
                return $.trim(value);
            },
            rules: {
                title: "required",
                firstname: "required",
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                title: "Please select your title",
                firstname: "Please enter your firstname",
                email: "Please enter a valid email address"
            }
        });
    }

    //register hotels form validation
    if ($('#register_you_hotel').length) {
        $("#register_you_hotel").validate({
            errorElement: 'span',
            errorClass: 'error jq-msg',
            normalizer: function (value) {
                return $.trim(value);
            },
            rules: {
                propertyname: "required",
                weburl: "required",
                type: "required",
                rating: "required",
                cityname: "required",
                online_booking: "required",
                payment: "required",
                rooms: "required"
            },
            messages: {
                propertyname: "Please enter your Hotel / Property name",
                weburl: "Please enter your Website URL",
                type: "Please select your type",
                rating: "Please select your Rating",
                cityname: "Please enter city",
                online_booking: "Please select",
                payment: "Please select",
                rooms: "Please enter Number of Rooms"
            }
        });
    }

    // offers slider mega menu
    menuOffersArgs = {
        items: 1,
        loop: 1,
        margin: 5,
        autoplay: 1,
        dots: true,
        autoplayHoverPause: false,
        animateOut: "fadeOut",
        navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#leftarrow"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#rightarrow"></use></svg>'],
        lazyLoad: !0,
        responsive: {
            1200: {
                nav: !0,
            },
            1600: {
                items: 1,
                nav: !0,
                margin: 42,
            }
        }
    }
    if ($('.owl-menu-offer').length) {
        $('.owl-menu-offer').owlCarousel(menuOffersArgs);
    }

    //one item slider
    oneItemArgs = {
        items: 1,
        loop: !1,
        margin: 10,
        autoplay: !0,
        dots: true,
        nav: true,
        autoplayHoverPause: true,
        //animateOut: "fadeOut", 
        lazyLoad: true,
    }

    if ($('.owl-one-item').length) {
        $('.owl-one-item').owlCarousel(oneItemArgs);
    }

    // room inner two items
    //one item slider
    twoItemArgs = {
        items: 1,
        loop: !1,
        margin: 10,
        autoplay: !0,
        dots: true,
        nav: true,
        autoplayHoverPause: true,
        //animateOut: "fadeOut", 
        lazyLoad: !0,
        responsive: {
            992: {
                items: 2,
                margin: 30,
            },
        }
    }

    if ($('.owl-two-item').length) {
        $('.owl-two-item').owlCarousel(twoItemArgs);
    }

    threeItemArgs = {
        items: 1,
        loop: !1,
        margin: 10,
        autoplay: !0,
        dots: true,
        nav: true,
        autoplayHoverPause: true,
        //animateOut: "fadeOut", 
        lazyLoad: !0,
        responsive: {
            992: {
                items: 2,
                margin: 30,
            },
            1354: {
                items: 3,
                margin: 30,
            },
        }
    }

    if ($('.owl-three-item').length) {
        $('.owl-three-item').owlCarousel(threeItemArgs);
    }


    // home guest reviews
    reviewsArgs = {
        items: 1,
        loop: !0,
        margin: 10,
        autoplay: !0,
        dots: true,
        nav: true,
        autoplayHoverPause: true,
        lazyLoad: !0,
        responsive: {
            1200: {
                nav: true,
            },
            1600: {
                nav: true,
            },
        }
    }

    if ($('.owl-reviews').length) {
        $('.owl-reviews').owlCarousel(reviewsArgs);
    }

    


    //home FAQ accordian 
    $('.collapse').on('shown.bs.collapse', function () {
        $(this).parent().addClass("active");
    }).on('hidden.bs.collapse', function () {
        $(this).parent().removeClass("active");
    });



    // Home - diverse destination section dropdown with show tabs area
    var tabDrop = $('#tab-dropdown-list');
    tabDrop.on('change', function (e) {
        $('#tab-list li a').eq($(this).val()).tab('show');
    });

})

// Get the input element and the element with class "closs_ibe"
var promocodeInput = document.getElementById('promocode');
var closeButton = document.querySelector('.closs_ibe');

// Add click event listener to the element with class "closs_ibe"
closeButton.addEventListener('click', function () {
    // Reset the input field value to an empty string
    promocodeInput.value = '';
});

/* ------------------------- executes when page resized ----------------------------- */

$(window).resize(function (e) {

    if ($(".plan-your-gateway-container").is(":visible")) {

        //change plan your gateway close button when popup is opened
        if (!$("#plan-your-gateway-btn-mobile").hasClass("open")) {
            $("#plan-your-gateway-btn-mobile").addClass("open");
        }

        //change plan your gateway close button when popup is opened
        if (!$("#plan-your-gateway-btn-desktop").hasClass("open")) {
            $("#plan-your-gateway-btn-desktop").addClass("open");
        }
    }
});

/* ------------------- executes when the html document is loaded and the dom is ready ---------------- */

$(document).ready(function (e) {
    var displayMonths;
    var appendNode = $("body")[0];

    if (isMobile()) {
        displayMonths = 1;
    } else {
        displayMonths = 2;
    }



    // if (isMobile(1200)) {
    // } else {
    //     appendNode = $(".calender-wrapper")[0];
    // }
    // IBE 
    //date format pure js
    function appendLeadingZeroes(n) {
        if (n <= 9) {
            return "0" + n;
        }
        return n
    }

    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    //IBE page datepickers
    if ($('.booking-form').length) {
        var fp = flatpickr(".booking-form", {
            mode: "range",
            minDate: "today",
            maxDate: new Date().fp_incr(1825), // 5 year from now
            altInput: true,
            altInputClass: "d-none",
            allowInput: false,
            dateFormat: "Y-M-l-d",
            wrap: true,
            showMonths: 1,
            clickOpens: false,
            appendTo: document.querySelectorAll('.booking-form .booking-datepicker')[0],
            onChange: function (selectedDates, dateStr, instance) {
                var dateArr = selectedDates.map(function (date) {
                    // var formatted_date = appendLeadingZeroes(date.getMonth() + 1) + "/" + appendLeadingZeroes(date.getDate())+'/'+date.getFullYear()
                    var formatted_date = appendLeadingZeroes(date.getDate()) + '/' + appendLeadingZeroes(date.getMonth() + 1) + '/' + date.getFullYear()
                    return formatted_date;
                });

                if (dateArr[0] != '') {
                    $('#checkin-date').val(dateArr[0]);
                }
                //set c out value
                if (typeof dateArr[1] != 'undefined') {
                    $('#checkout-date').val(dateArr[1]);
                }

                var dateSplit = splitDate(dateStr, "to");

                addDatestoBlocks('check-in-box', dateSplit[0]);
                addDatestoBlocks('check-out-box', dateSplit[1]);
            },
            onClose: function (selectedDates, dateStr, instance) {
                if (selectedDates.length == 1) {

                    var chInDate = '';
                    // Make checkin date for range
                    if (selectedDates[0] != 'undefined') {
                        var makeChekin = appendLeadingZeroes(selectedDates[0].getMonth() + 1) + "/" + appendLeadingZeroes(selectedDates[0].getDate()) + '/' + selectedDates[0].getFullYear();
                        chInDate = makeDateasValue(makeChekin);
                        chInDate = new Date(chInDate);
                        chInDate = chInDate.getFullYear() + '-' + months[chInDate.getMonth()] + "-" + getWeekDayName(chInDate.getDay()) + '-' + appendLeadingZeroes(chInDate.getDate());
                    }

                    // set next date as by clicked date
                    var clickedDate = selectedDates[0];
                    // Get old date
                    var checkOutDate = $('#checkout-date').val();
                    returningDate = makeDateasValue(checkOutDate);
                    var mkReturningDate = new Date(returningDate);

                    // Make next date
                    var dateOne = clickedDate;
                    dateOne.setDate(clickedDate.getDate() + 1);
                    var formatted_date = appendLeadingZeroes(dateOne.getDate()) + '/' + appendLeadingZeroes(dateOne.getMonth() + 1) + '/' + dateOne.getFullYear();
                    var outDate = makeDateasValue(formatted_date);
                    var mkOutDate = new Date(outDate);

                    var setCheckout = ''; // Checkout date for datepicker
                    // Add Checkout date to field
                    if (mkReturningDate <= mkOutDate) {
                        $('#checkout-date').val(formatted_date);
                        // 2020-June-Wednesday-17 
                        var setCheckout = mkOutDate.getFullYear() + '-' + months[mkOutDate.getMonth()] + "-" + getWeekDayName(mkOutDate.getDay()) + '-' + appendLeadingZeroes(mkOutDate.getDate());
                        addDatestoBlocks('check-out-box', setCheckout);
                    } else {
                        var setCheckout = mkReturningDate.getFullYear() + '-' + months[mkReturningDate.getMonth()] + "-" + getWeekDayName(mkReturningDate.getDay()) + '-' + appendLeadingZeroes(mkReturningDate.getDate());
                    }

                    var datesWithSemiColon = [chInDate, setCheckout];
                    setTimeout(function () {
                        updateCalenderRange(datesWithSemiColon);
                    }, 300);
                }
            },
        });

        function updateCalenderRange(datesList) {
            fp.setDate(datesList, false, 'Y-F-l-d');
        }
    }

    function makeDateasValue(date) {
        var datesArray = date.split('/');
        return datesArray[2].trim() + '-' + datesArray[0].trim() + '-' + datesArray[1].trim();
    }

    // add dates to UI elements
    function addDatestoBlocks(el, dateSplit) {
        if (dateSplit != undefined) {
            var arrivalDate = splitDate(dateSplit, "-");
            var arrivalYear = arrivalDate[0];
            var arrivalMonth = arrivalDate[1];
            var arrivalDateName = arrivalDate[2];
            var arrivalDateNum = arrivalDate[3];

            $('#' + el + ' .date-month-year .month').text(arrivalMonth);
            $('#' + el + ' .date-month-year .year').text(arrivalYear);
            $('#' + el + ' .date-number').text(arrivalDateNum);
            $('#' + el + ' .day-name').text(arrivalDateName);
        }
    }

    function getWeekDayName(day) {
        var weekdays = new Array(7);
        weekdays[0] = "Sunday";
        weekdays[1] = "Monday";
        weekdays[2] = "Tuesday";
        weekdays[3] = "Wednesday";
        weekdays[4] = "Thursday";
        weekdays[5] = "Friday";
        weekdays[6] = "Saturday";
        return weekdays[day];
    }

    /* animation args */
    animargs = {
        opacity: "toggle"
    }

    /* main navigation */
    hamburgerdrop('.mainmenutoggle', '.main-menu-container', animargs);

    /**
     * Plan your trip section
     */
    hamburgerdrop('#plan-your-gateway-btn-mobile', '.plan-your-gateway-container', animargs);
    hamburgerdrop('#plan-your-gateway-btn-desktop', '.plan-your-gateway-container', animargs);

    hamburgerdrop('.shareparent .menu-toggle , .leftnav-title', '#left-navbar', animargs);

});

function splitDate(splitDate, splitString) {
    var splitDate = splitDate.split(splitString);
    return splitDate;
}

function isMobile(width) {
    if (width == undefined) {
        width = 768;
    }
    if (window.innerWidth <= width) {
        return true;
    } else {
        return false;
    }
}

function isLargerThan(width) {
    if (width == undefined) {
        width = 1200;
    }
    if (window.innerWidth >= width) {
        return true;
    } else {
        return false;
    }
}


$(".header-stripe-covid .closed").click(function (e) {
    $(".header-stripe-covid").hide();
    $(".main-navigation").removeClass('has_covid');
});


// Lazy load images - browser native
$(document).ready(function () {
    $('img').attr('loading', 'lazy');
    $('iframe').attr('loading', 'lazy');

    $('#eme-slider-wrap-full-screen img').attr('loading', 'eager');

});

jQuery(document).ready(function($) {
    $('.exp-wrapper--mobile').owlCarousel({
        items: 1,
        margin: 15,
        nav: true,
        dots: true,
        responsive: {
            0: { items: 1 },
            600: { items: 2 },
            992: { items: 3 }
        }
    });
});